import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAdminStore } from '../stores/adminStore';
import { authApi } from '../api/client';
import styles from './AdminLayout.module.css';

const navItems = [
  { path: '/', label: 'Dashboard', minRole: 'support' as const },
  { path: '/accounts', label: 'Accounts', minRole: 'support' as const },
  { path: '/moderation', label: 'Moderation', minRole: 'mod' as const },
  { path: '/audit', label: 'Audit Log', minRole: 'support' as const },
  { path: '/devices', label: 'Devices', minRole: 'super' as const },
  { path: '/settings', label: 'Settings', minRole: 'super' as const },
  { path: '/errors', label: 'Errors', minRole: 'support' as const },
  { path: '/request-logs', label: 'Requests', minRole: 'support' as const },
];

export function AdminLayout() {
  const navigate = useNavigate();
  const { role, clearSession, hasRole } = useAdminStore();

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch {
      // Ignore logout errors
    }
    clearSession();
    navigate('/login');
  };

  return (
    <div className={styles.container}>
      <aside className={styles.sidebar}>
        <div className={styles.logo}>
          <span className={styles.logoText}>WARMANCER</span>
          <span className={styles.logoSub}>Admin</span>
        </div>

        <nav className={styles.nav}>
          {navItems
            .filter((item) => hasRole(item.minRole))
            .map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
                }
              >
                {item.label}
              </NavLink>
            ))}
        </nav>

        <div className={styles.sidebarFooter}>
          <div className={styles.roleInfo}>
            <span className={styles.roleLabel}>Logged in as</span>
            <span className={styles.roleBadge}>{role}</span>
          </div>
          <button className={styles.logoutBtn} onClick={handleLogout}>
            Logout
          </button>
        </div>
      </aside>

      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
